import { faPenAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useCategories } from "./contexts/CategoriesContext";
import { CategoryDetails } from "./models/CategoryDetails";
import { useResize } from "../../hooks/useResize";
import { usePreserve } from "../../contexts/PreserveContext";
import { useLocalization } from "../../contexts/LocalizationContext";

type CategoriesTableReadonlyRowProps = {
  item: CategoryDetails;
  index: number;
  onDelete: () => void;
};

export const CategoriesTableReadonlyRow = ({ index, item, onDelete }: CategoriesTableReadonlyRowProps) => {
  const { onEditModeIdChange } = useCategories();
  const { isExpanded, onToggle } = useResize();
  const { safeExecute } = usePreserve();
  const { translate } = useLocalization();

  return (
    <tr className="d-flex flex-column d-xl-table-row text-center text-xl-start align-middle">
      <td className="d-none d-xl-table-cell">{index}</td>
      <td className="border fw-bold fw-xl-normal" onClick={onToggle}>
        {item.name}
      </td>
      {isExpanded && (
        <>
          <td className="border text-center">
            <OverlayTrigger overlay={<Tooltip>{translate("common.edit")}</Tooltip>}>
              <Button
                variant="transparent"
                className="p-0"
                aria-label={translate("common.edit")}
                onClick={() => safeExecute(() => onEditModeIdChange(item.id))}
              >
                <FontAwesomeIcon icon={faPenAlt} className="text-secondary" />
              </Button>
            </OverlayTrigger>
          </td>
          <td className="border text-center">
            <OverlayTrigger overlay={<Tooltip>{translate("common.delete")}</Tooltip>}>
              <Button variant="transparent" className="p-0" aria-label={translate("common.delete")} onClick={onDelete}>
                <FontAwesomeIcon icon={faTrashAlt} className="text-danger" />
              </Button>
            </OverlayTrigger>
          </td>
        </>
      )}
    </tr>
  );
};
